import React from 'react';
import { Users, Award, Leaf, ShieldCheck } from 'lucide-react';
export function TrustBar() {
  const trustItems = [{
    icon: Users,
    text: '100.000+ zufriedene Kunden'
  }, {
    icon: Award,
    text: 'Von Tierärzten empfohlen'
  }, {
    icon: Leaf,
    text: '100% pflanzlich & natürlich'
  }, {
    icon: ShieldCheck,
    text: 'Geld-zurück-Garantie'
  }];
  return <div className="w-full bg-forestGreen text-cream py-6 px-4" data-id="element-146">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-147">
        {trustItems.map((item, index) => <div key={index} className="flex flex-col items-center text-center gap-2" data-id="element-148">
            <item.icon size={28} className="opacity-90" data-id="element-149" />
            <span className="text-sm md:text-base font-medium font-serif leading-tight" data-id="element-150">
              {item.text}
            </span>
          </div>)}
      </div>
    </div>;
}